import { render, staticRenderFns } from "./MagicTree.vue?vue&type=template&id=37d88f13&scoped=true&"
import script from "./MagicTree.js?vue&type=script&lang=js&"
export * from "./MagicTree.js?vue&type=script&lang=js&"
import style0 from "./MagicTree.css?vue&type=style&index=0&id=37d88f13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d88f13",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
